// @flow
function loadUmami() {
  if (window.isUmamiLoaded) return;
  window.isUmamiLoaded = true;

  const scriptNode = document.createElement('script');
  scriptNode.src = CONFIG.umami.src;
  scriptNode.async = true;
  scriptNode.defer = true;
  scriptNode.dataset.websiteId = CONFIG.umami.id;
  document.getElementsByTagName('head')[0].appendChild(scriptNode);
}

function createGtagScriptNode(tagId) {
  const scriptNode = document.createElement('script');
  scriptNode.async = true;
  scriptNode.src = `https://www.googletagmanager.com/gtag/js?id=${tagId}`;
  document.getElementsByTagName('head')[0].appendChild(scriptNode);
}

function loadGtag() {
  if (window.isGtagLoaded) return;
  window.isGtagLoaded = true;
  window.dataLayer = window.dataLayer || [];
  function gtag(...args) {
    window.dataLayer.push(args);
  }
  gtag('js', new Date());

  gtag('config', 'AW-16454153616');

  createGtagScriptNode('AW-16454153616');

  const promoPathRegex = /^\/([a-zA-Z]{2,}(-[a-zA-Z]{2,})?)\/promo\//;
  if (promoPathRegex.test(window.location.pathname)) {
    gtag('js', new Date());
    gtag('config', 'GTM-N694H8NX');
    createGtagScriptNode('GTM-N694H8NX');
  }
}

export const PRIVACY_ACCEPT_KEY = 'privacy-accept-response';

export const EU_MEMBERS = [
  'BE',
  'BG',
  'CZ',
  'DK',
  'DE',
  'EE',
  'IE',
  'EL',
  'ES',
  'FR',
  'HR',
  'IT',
  'CY',
  'LV',
  'LT',
  'LU',
  'HU',
  'MT',
  'NL',
  'AT',
  'PL',
  'PT',
  'RO',
  'SI',
  'SK',
  'FI',
  'SE'
];

export function declinePrivacyPrompt() {
  window.localStorage.setItem(PRIVACY_ACCEPT_KEY, 'false');
}

export function acceptPrivacyPrompt() {
  window.localStorage.setItem(PRIVACY_ACCEPT_KEY, 'true');
}

export function deferredLoad() {
  const loadFunc = () => {
    loadUmami();
    loadGtag();
  };
  if (window.tsPageInteracted) {
    loadFunc();
  } else {
    window.addEventListener(
      'scroll',
      () => {
        // the timeout ensures this is not executed as part of the
        // critical application execution path, reducing Time To Interactive
        setTimeout(loadFunc, 1000);
      },
      { once: true }
    );
  }
}

if (typeof window !== 'undefined') {
  if (!window.dataLayer) {
    window.dataLayer = window.dataLayer || [];
  }
}
